import { useTranslation } from 'react-i18next';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import Button from 'components/Button/Button';
import Loader from 'components/Loader/Loader';
import Modal from 'components/Modal/Modal';
import TextField from 'components/TextField/TextField';
import { TASK_SUPPLIERS_MINI_STAKEHOLDERS_CONFIG_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import SelectSupplierTable from '../SelectSupplierTable/SelectSupplierTable';

import type ISupplierListModal from './interfaces/ISupplierListModal';

import styles from './scss/SupplierListModal.module.scss';

function SupplierListModal({
  open, onClose, title, onConfirm, isLoading,
  isEmptyList, selectedItems, setSelectedItems,
  vcSuppliers, search, onSearchChange, setUnSelectedItems,
  loadMoreVCSuppliers, hasMoreVCSuppliers,
}: ISupplierListModal) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
      isLoading={isLoading}
    >
      <div className={styles.root}>
        <div className={styles.wrapperContent}>
          <div className={styles.searchWrapper}>
            <TextField
              name="search"
              value={search}
              placeholder={t('common.search')}
              icon={<SearchIcon />}
              onChange={(event) => {
                onSearchChange(event.target.value);
              }}
              required
            />
          </div>

          <div className={styles.tableWrapper}>
            {isLoading ? <Loader isPageLoading isFullLoader={false} /> : (
              <SelectSupplierTable
                headerCells={TASK_SUPPLIERS_MINI_STAKEHOLDERS_CONFIG_CELLS}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                vcSuppliers={vcSuppliers}
                setUnSelectedItems={setUnSelectedItems}
                loadMoreVCSuppliers={loadMoreVCSuppliers}
                hasMoreVCSuppliers={hasMoreVCSuppliers}
              />
            )}
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={onClose}
          />
          <Button
            title={t('common.add')}
            onClick={onConfirm}
            className={styles.button}
            disabled={isEmptyList}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SupplierListModal;
